import Container from "../../Components/Atoms/layouts/container/Container";
import { useEffect } from 'react';


export default function RegistrationCompleted() {

  const registrationData = JSON.parse(sessionStorage.getItem("RegistrationData"))

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);

    window.fbq && window.fbq('track', 'ViewContent');


    return () => {
      document.head.removeChild(meta);
    };
  }, []);


  return (
    <div className="other-page-container bg-color-brand-color1 color-fff">
      <Container className="">
        <div className="p-80 simple-para">
          <h1>Thanks for your registration</h1>
          <p className="mt-10">We have recieved your registration for a tution. We'll further contact you via your phone number and email id.

            <br /><br />
            Your registration details has been sent to your email id : <b>{registrationData?.parent_email}</b>

            <br /><br />
            If you have any querries, you may visit our <a href="https://www.lushaitech.com/contact" target="_blank">contact page</a> to raise your concerns.
          </p>
        </div>
      </Container>
    </div>
  )
}